<template>
  <b-card>
    <monitoramento-list
      ref="monitoramentoList"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="true"
      :show-botao-custom="true"
      :tem-filtro-rapido="false"
      :esconder-acoes="true"
      :mostrar-acoes-padrao="false"
      :row-style-class="rowStyleClass"
      class="monitoramentoHover"
      @carregado="empresasGridAtual = $event"
      @selected-rows-change="empresasSelecionadasAtual = $event"
    >
      <template slot="show-botao-custom">
        <div
          class="d-flex align-items-center"
          style="gap: 0.5rem;"
        >
          <download-em-excel
            :filtro="filtroAtual"
            tipo="Monitoramento 360"
            :api="apiMonitoramento"
            :get-info-extra="montarDto"
          />
          <envio-email-em-lote
            :empresas-selecionadas="empresasSelecionadasAtual"
            :empresas-grid="empresasGridAtual"
            title="Enviar documentos do Monitoramento 360 (desta página) por e-mail"
            nome-arquivo="Monitoramento 360"
            :evento="enviarEmailEmLote"
            :evento-verificar-email="apiMonitoramento.verificarEmail"
          />
        </div>
      </template>
      <template slot="busca-extra">
        <b-form-checkbox
          v-model="telaDetalhada"
          switch
          @change="alternarTelaDetalhada"
        >
          Tela detalhada
        </b-form-checkbox>
      </template>
      <template slot="filtro-extra">
        <b-row>
          <b-col cols="6">
            <v-select
              v-model="filtroString"
              :options="filtrosRapidosDocs"
              multiple
              :disabled="filtroCustom != null"
              placeholder="Tipos de documentos"
              @input="mudarDocSelecionado"
            />
          </b-col>
          <b-col cols="6">
            <filtro-custom
              ref="filtroCustomModal"
              :api="apiFiltroCustom"
              :filtros-default-docs="filtrosDefaultDocs"
              @aplicarFiltro="aplicarFiltroCustom"
            />
          </b-col>
        </b-row>
      </template>
      <template
        slot="custom-header"
        slot-scope="{ props} "
      >
        <div
          class="d-flex align-items-center justify-content-between grupo-header"
          :class="`grupo-header-${props.column.field}`"
        >
          <span>{{ props.column.label }}</span>
          <b-button
            variant="light"
            size="sm"
            class="ml-1 d-flex align-items-center justify-content-center"
            @click.stop="props.column.field === 'situacao' ? alternarSituacaoGeral() : visualizarGrupo(props.column.field) "
          >
            <feather-icon
              :icon="props.column.field === 'situacao'
                ? (expandindoSituacaoGeral ? 'ChevronLeftIcon' : 'ChevronRightIcon')
                : (colunasExpandidas[props.column.field] ? 'ChevronDownIcon' : 'ChevronRightIcon')"
              size="15"
            />
          </b-button>
        </div>
      </template>

      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <tooltip-situacao
          v-if="props.column.field === 'situacao'"
          :row="props.row"
          class="situacao-cell-hover"
        >
          <span
            v-if="props.row[props.column.field] === 'regular'"
            class="status-chip status-chip-regular"
          >
            <feather-icon
              icon="CheckCircleIcon"
              size="20"
              class="icone-status-regular"
            />
          </span>
          <span
            v-else-if="props.row[props.column.field] === 'irregular'"
            class="status-chip status-chip-irregular"
          >
            <feather-icon
              icon="XCircleIcon"
              size="20"
              class="icone-status-irregular"
            />
          </span>
          <span
            v-else-if="props.row[props.column.field] === 'motivo'"
            class="status-chip status-chip-motivo"
          >
            <feather-icon
              icon="MinusCircleIcon"
              size="20"
              class="icone-status-motivo"
            />
          </span>
          <b-badge
            v-else
            variant="light-secondary"
            class="badge-size-p"
          >
            -
          </b-badge>
        </tooltip-situacao>
        <span
          v-else-if="props.row[props.column.field] === 'regular'"
          class="status-chip status-chip-regular"
        >
          <feather-icon
            icon="CheckCircleIcon"
            size="20"
            class="icone-status-regular"
          />
        </span>
        <span
          v-else-if="props.row[props.column.field] === 'irregular'"
          class="status-chip status-chip-irregular"
        >
          <feather-icon
            icon="XCircleIcon"
            size="20"
            class="icone-status-irregular"
          />
        </span>
        <span
          v-else-if="props.row[props.column.field] === 'motivo'"
          class="status-chip status-chip-motivo"
        >
          <feather-icon
            icon="MinusCircleIcon"
            size="20"
            class="icone-status-motivo"
          />
        </span>
        <b-badge
          v-else-if="props.column.field !== 'situacao'"
          variant="light-secondary"
          class="badge-size-p"
        >
          -
          {{ props.row[props.column.field] }}
        </b-badge>
      </template>

      <template
        slot="acoes"
        slot-scope="{ props }"
      >
        <div class="acoes-wrapper">
          <div class="acoes-grupo">
            <span
              v-b-tooltip.hover
              title="Visualizar pendências"
            >
              <b-btn
                variant="none"
                class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
                @click="abrirPendencias(props.row)"
              >
                <font-awesome-icon
                  :icon="faMagnifyingGlass"
                  class="text-primary"
                />
              </b-btn>
            </span>

            <span
              v-b-tooltip.hover
              title="Download documentos"
            >
              <b-btn
                variant="none"
                class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
                @click="baixarDocumentos(props.row)"
              >
                <feather-icon
                  icon="DownloadIcon"
                  class="text-primary"
                  size="20"
                />
              </b-btn>
            </span>

            <span
              v-b-tooltip.hover
              title="Visualizar documentos"
            >
              <b-btn
                variant="none"
                class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
                @click="visualizarDocumentos(props.row)"
              >
                <font-awesome-icon
                  icon="fa-sharp fa-regular fa-clipboard"
                  class="text-primary"
                  style="font-size:1.3rem !important;width:22px"
                />
              </b-btn>
            </span>
          </div>

          <div class="acoes-grupo">
            <span
              v-b-tooltip.hover
              title="Enviar e-mail"
            >
              <b-btn
                variant="none"
                class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
                @click="abrirEnvioEmail(props.row)"
              >
                <feather-icon
                  icon="SendIcon"
                  :class="props.row.emailEnviado ? 'text-success' : 'text-primary'"
                  size="20"
                />
              </b-btn>
            </span>

            <span
              v-b-tooltip.hover
              title="Observação"
            >
              <b-btn
                variant="none"
                class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
                @click="openModalObservacao(props.row)"
              >
                <font-awesome-icon
                  icon="fa-regular fa-message"
                  :class="getObservacaoClass(props.row)"
                />
              </b-btn>
            </span>

            <span
              v-b-tooltip.hover
              title="WhatsApp"
            >
              <b-btn
                variant="none"
                class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
                @click="abrirWhatsapp(props.row)"
              >
                <font-awesome-icon
                  icon="fa-brands fa-whatsapp"
                  :class="props.row.whatsappEnviado ? 'text-success' : 'text-primary'"
                  style="font-size: 20px !important;"
                />
              </b-btn>
            </span>
          </div>
        </div>
      </template>
    </monitoramento-list>
    <div
      ref="legenda"
    >
      <span class="text-nowrap item-legenda">
        Legenda:
        <feather-icon
          icon="CheckCircleIcon"
          size="25"
          class="icone-status-regular"
        />
        <span class="text-nowrap">
          Regular
        </span>
      </span>

      <span class="text-nowrap item-legenda">
        <feather-icon
          icon="XCircleIcon"
          size="25"
          class="icone-status-irregular"
        />
        Irregular
      </span>

      <span class="text-nowrap item-legenda">
        <feather-icon
          icon="MinusCircleIcon"
          size="25"
          class="icone-status-motivo"
        />
        Motivo
      </span>

      <span class="text-nowrap item-legenda">
        <b-badge
          variant="light-secondary"
          class="badge-size-p"
        >
          -
        </b-badge>
        Sem dados
      </span>
    </div>

    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="descricaoLoading"
    />

    <pendencias-monitoramento-360
      v-if="empresaSelecionada"
      :empresa-id="empresaSelecionada.id"
      :empresa-nome="empresaSelecionada.razaoSocial"
      @hidden="empresaSelecionada = null"
    />

    <modal-observacao
      v-if="empresaObservacao"
      ref="modalObservacao"
      v-model="empresaObservacao"
      :api="apiMonitoramento"
      :notificar="{ sucesso: $sucesso, erro: $erro }"
      @hidden="fecharObservacao($event)"
    />

    <visualizar-arquivo
      v-if="mostrarVisualizacao && urlVisualizacao"
      :url="urlVisualizacao"
      @hidden="fecharVisualizacao()"
    />

    <envio-email
      v-if="empresaEmailSelecionada"
      ref="modalEnvioEmail"
      :title="`Enviar documentos ${empresaEmailSelecionada.razaoSocial}`"
      :sugestao="empresaEmailSelecionada.email"
      :sugestao-email-adicional="empresaEmailSelecionada.emailAdicionalEmpresa"
      @enviarEmail="enviarEmailAction"
      @hide="empresaEmailSelecionada = null"
    />
  </b-card>
</template>

<style lang="scss">
// deixa colunas fixas na tela
.col-sticky {
  position: sticky !important;
  background: white !important;
}

// coloca a coluna de razão social como primeira coluna fixa
.col-sticky-1 {
  left: 0 !important;
  min-width: 250px !important;
}

// coloca a coluna de cadastro federal como segunda coluna fixa
.col-sticky-2 {
  left: 248px !important;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
}

// deixa o cabeçalho a frente dos outros
.frente {
  z-index: 1;
}

// deixa coluna de ações fixa a direita
.col-sticky-right {
  position: sticky !important;
  right: 0 !important;
  background: white !important;
  box-shadow: -2px 0 4px rgba(0, 0, 0, 0.08);
}

.acoes-wrapper {
  position: sticky;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.acoes-grupo {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.col-valores {
  white-space: nowrap;
}

[dir] #baixaPortalSelect .vs__dropdown-toggle {
  border-color: var(--primary) !important;
}

.item-legenda {
  margin: 5rem;
}

// diminui o campo de busca por texto para dar mais espaço aos filtros ao lado
// (.search-group é a classe própria do BuscaInput, não do grid Bootstrap —
// prefixada por .monitoramentoHover para não afetar outras telas)
.monitoramentoHover .search-group {
  max-width: 320px;
}

// garante que o span wrapper do vue-good-table não restrinja o tooltip
.vgt-table td .situacao-cell-hover {
  display: flex !important;
  width: 100%;
}

// tingimento do fundo da linha conforme a Situação Geral — colunas
// sticky sempre excluídas via :not(), senão o fundo semi-transparente deixa
// vazar o conteúdo das colunas que passam por baixo no scroll horizontal.
.vgt-table tbody tr.linha-regular td:not(.col-sticky):not(.col-sticky-right) {
  background-color: rgba(116, 180, 145, 0.15) !important;
}

.vgt-table tbody tr.linha-irregular td:not(.col-sticky):not(.col-sticky-right) {
  background-color: rgba(234, 84, 85, 0.07) !important;
}

.vgt-table tbody tr.linha-motivo td:not(.col-sticky):not(.col-sticky-right) {
  background-color: rgba(40, 48, 70, 0.1) !important;
}

// chip de status das colunas de situação
.status-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin: 0 5px;
}

.status-chip-regular {
  background-color: rgba(116, 180, 145, 0.16);
}

.status-chip-irregular {
  background-color: rgba(234, 84, 85, 0.16);
}

.status-chip-motivo {
  background-color: rgba(40, 48, 70, 0.08);
}

// cores de status consolidadas (evita repetir hex inline pelo template)
.icone-status-regular {
  margin: 0 5px;
  color: #74B491;
}

.icone-status-irregular {
  margin: 0 5px;
  color: #EA5455;
}

.icone-status-motivo {
  margin: 0 5px;
  color: #283046;
}

// identidade visual por grupo de colunas
.grupo-header {
  border-top: 3px solid transparent;
  padding-top: 4px;
}

.grupo-header-federal {
  border-top-color: #7367f0;
}

.grupo-header-certidoes {
  border-top-color: #6610f2;
}

.grupo-header-parcelamentos {
  border-top-color: #ff9f43;
}

.grupo-header-simplesNacionalInfo {
  border-top-color: #00cfe8;
}
</style>

<script>
import vSelect from 'vue-select'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import envioHistoricoApi from '@app/shared/services/envio-historico-api'
import filtroCustomApi from '@pilar/components/filtro-custom/filtroCustomApi'
import configuracaoTelaApi from '@app/shared/services/configuracao-tela-api'
import api from './shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'
import colunas from './shared/components/colunas'

const RECURSO_MONITORAMENTO_360 = 33

const DOC_TO_COLUNA = {
  'Situação Fiscal': 'situacaoFiscal',
  'Declaração DCTFWeb': 'dctfWeb',
  'CND RFB/PGFN': 'cndRfbPgft',
  'CND FGTS': 'cndFgts',
  'CND Trabalhista': 'cndTrabalhista',
  'CND Estadual': 'cndEstadual',
  'CND Municipal': 'cndMunicipal',
  'Parcelamento Das': 'simplesNacional',
  'Parcelamento Pert': 'pert',
  'Parcelamento Relp': 'relp',
  'Parcelamento Rfb': 'rfb',
  'Parcelamento não previdenciario': 'naoPrevidenciario',
  'Parcelamento simplificado previdenciario': 'simplificadoPrevidenciario',
  'Parcelamento PGFN': 'pgfn',
  Sublimite: 'sublimite',
  Das: 'das',
}

export default {
  name: 'Monitoramento360View',
  components: {
    vSelect,
    MonitoramentoList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    VisualizarArquivo: () => import('@pilar/components/visualizar-arquivo/VisualizarArquivo.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
    TooltipSituacao: () => import('./shared/components/tooltip-situacao/TooltipSituacao.vue'),
    PendenciasMonitoramento360: () => import('./shared/components/pendencias/PendenciasMonitoramento360.vue'),
    ModalObservacao: () => import('@app/shared/components/modal-observacao/ModalObservacao.vue'),
    EnvioEmail: () => import('@/app/shared/components/envio-email/EnvioEmail.vue'),
    EnvioEmailEmLote: () => import('@/app/shared/components/envio-email-lote/EnvioEmailEmLote.vue'),
    FiltroCustom: () => import('@pilar/components/filtro-custom/FiltroCustom.vue'),
  },

  data() {
    return {
      faMagnifyingGlass,
      mostarArquivo: false,
      arquivo: '',
      empresaNome: '',
      empresaSelecionada: null,
      empresaEmailSelecionada: null,
      botoesOption: null,
      empresaObservacao: null,
      observacaoEstado: {},
      mostrarVisualizacao: false,
      urlVisualizacao: null,
      descricaoLoading: '',
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social',
        acaoClass: 'col-td-acao-4',
        disabledCheckbox: false,
        colunas: [],
      },
      filtros: [
        {
          colunas: [
            'CadastroFederalSemMascara',
            'CadastroFederal',
            'RazaoSocial',
          ],
          valor: null,
        },
      ],
      filtrosDefaultDocs: [],
      filtrosRapidosDocs: [],
      filtrosRapidos: [],
      filtroString: [],
      filtroCustom: null,
      filtroAtual: {},
      empresasGridAtual: [],
      empresasSelecionadasAtual: [],
      apiMonitoramento: api,
      apiFiltroCustom: filtroCustomApi('monitoramento_360'),
      apiConfiguracaoTela: configuracaoTelaApi(RECURSO_MONITORAMENTO_360),
      telaDetalhada: false,
      isLoading: false,
      colunasExpandidas: {
        federal: false,
        certidoes: false,
        parcelamentos: false,
        simplesNacionalInfo: false,
      },
      expandindoSituacaoGeral: false,
    }
  },
  created() {
    this.visualizacao.colunas = JSON.parse(JSON.stringify(colunas))
    this.visualizacao.evento = this.carregar
    this.filtrosDefaultDocs = ['Todos', ...Object.keys(DOC_TO_COLUNA)]
    this.filtrosRapidosDocs = this.filtrosDefaultDocs
    this.carregarConfiguracaoTela()
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    rowStyleClass(row) {
      if (row.situacao === 'regular') return 'linha-regular'
      if (row.situacao === 'irregular') return 'linha-irregular'
      if (row.situacao === 'motivo') return 'linha-motivo'
      return ''
    },
    montarDto() {
      if (this.$refs.monitoramentoList) {
        const empresas = this.$refs.monitoramentoList.linhaSelecionada
        this.filtroAtual.empresasSelecionadas = !empresas ? [] : empresas
        const docs = this.resolverFiltroParaEnviar()
        const filtroByAtual = (this.filtroAtual.filtroBy ?? []).filter(f => !f.colunas.includes('MultiFiltro'))
        this.filtroAtual.filtroBy = [...filtroByAtual, { colunas: ['MultiFiltro'], valor: docs.length > 0 ? docs.join(',') : null }]
        return this.filtroAtual
      }
      return undefined
    },
    carregarConfiguracaoTela() {
      this.apiConfiguracaoTela.obter().then(payload => {
        if (!payload.data) return
        const configuracao = typeof payload.data === 'string' ? JSON.parse(payload.data) : payload.data
        this.telaDetalhada = !!configuracao.telaDetalhada
        if (this.telaDetalhada) {
          this.$nextTick(() => this.aplicarTelaDetalhada(true))
        }
      }).catch(err => {
        this.$erro(err)
      })
    },
    aplicarTelaDetalhada(valor) {
      if (valor) {
        this.expandindoSituacaoGeral = true
        Object.keys(this.colunasExpandidas).forEach(grupo => {
          this.colunasExpandidas[grupo] = true
        })
        this.visualizacao.colunas.forEach(col => {
          if (col.grupo) {
            this.$set(col, 'visible', true)
          }
        })
        return
      }

      this.resetarEstadoColunas()
      this.visualizacao.colunas.forEach(col => {
        if (col.grupo) {
          this.$set(col, 'visible', false)
        }
      })
    },
    alternarTelaDetalhada() {
      this.aplicarTelaDetalhada(this.telaDetalhada)
      this.apiConfiguracaoTela.salvar(JSON.stringify({ telaDetalhada: this.telaDetalhada })).catch(() => {
        this.$erro('Não foi possível salvar a preferência de tela detalhada')
      })
    },
    resetarEstadoColunas() {
      this.expandindoSituacaoGeral = false
      Object.keys(this.colunasExpandidas).forEach(grupo => {
        this.colunasExpandidas[grupo] = false
      })
    },
    alternarSituacaoGeral() {
      this.expandindoSituacaoGeral = !this.expandindoSituacaoGeral

      this.visualizacao.colunas.forEach(col => {
        if (['federal', 'certidoes', 'parcelamentos', 'simplesNacionalInfo'].includes(col.field)) {
          // eslint-disable-next-line no-param-reassign
          col.visible = this.expandindoSituacaoGeral
        } else if (col.grupo && !['federal', 'certidoes', 'parcelamentos', 'simplesNacionalInfo'].includes(col.field)) {
          // eslint-disable-next-line no-param-reassign
          col.visible = false
        }
      })
    },
    visualizarGrupo(grupo) {
      const expandido = this.colunasExpandidas[grupo]
      this.colunasExpandidas[grupo] = !expandido

      this.visualizacao.colunas.forEach(col => {
        if (col.grupo === grupo && col.thType !== 'custom-header') {
          // eslint-disable-next-line no-param-reassign
          col.visible = !expandido
        }
      })
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.monitoramentoList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.monitoramentoList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
      this.aplicarLegenda()
    },
    aplicarLegenda() {
      const interval = setInterval(() => {
        const totalPaginadoDiv = document.getElementById('TotalPagina')
        const spanElement = this.$refs.legenda
        totalPaginadoDiv.appendChild(spanElement)
        clearInterval(interval)
      }, 100)
    },
    abrirPendencias(row) {
      this.empresaSelecionada = row
    },
    baixarDocumentos(row) {
      this.descricaoLoading = 'Aguarde!'
      this.isLoading = true
      api.baixarDocumentos(row.id, this.resolverFiltroParaEnviar()).then(payload => {
        window.open(payload.data)
      }).catch(() => {
        this.$erro('Não foi possível gerar o download dos documentos')
      }).finally(() => {
        this.isLoading = false
        this.descricaoLoading = ''
      })
    },
    visualizarDocumentos(row) {
      this.descricaoLoading = 'Estamos quase lá! Sua visualização está sendo preparada. Aguarde alguns instantes.'
      this.isLoading = true
      api.visualizarDocumentos(row.id, this.resolverFiltroParaEnviar()).then(payload => {
        this.urlVisualizacao = payload.data
        this.mostrarVisualizacao = true
      }).catch(() => {
        this.$erro('Não foi possível gerar a visualização dos documentos')
      }).finally(() => {
        this.isLoading = false
        this.descricaoLoading = ''
      })
    },
    fecharVisualizacao() {
      this.mostrarVisualizacao = false
      this.urlVisualizacao = null
    },
    openModalObservacao(row) {
      this.empresaObservacao = row
      this.$nextTick(() => {
        if (this.$refs.modalObservacao) {
          this.$refs.modalObservacao.show()
        } else {
          this.$once('hook:updated', () => {
            if (this.$refs.modalObservacao) this.$refs.modalObservacao.show()
          })
        }
      })
    },
    getObservacaoClass(row) {
      const estado = this.observacaoEstado[row.id]
      const todasLidas = estado ? estado.todasObservacoesLidas : row.todasObservacoesLidas
      const temNaoLidas = estado ? estado.temObservacoesNaoLidas : row.temObservacoesNaoLidas
      return {
        'text-success': todasLidas,
        'text-warning': !todasLidas && temNaoLidas,
        'text-primary': !temNaoLidas && !todasLidas,
      }
    },
    fecharObservacao(event) {
      if (this.empresaObservacao) {
        this.$set(this.observacaoEstado, this.empresaObservacao.id, {
          temObservacao: !!(event.hasObservacaoNova || event.observacaoLida),
          temObservacoesNaoLidas: !!event.hasObservacaoNova,
          todasObservacoesLidas: !!event.observacaoLida,
        })
      }
      this.empresaObservacao = null
    },
    resolverFiltroParaEnviar() {
      if (this.filtroCustom) return this.filtroCustom.filtrosDocs ?? []
      if (this.filtroString.length === 0 || this.filtroString.includes('Todos')) return []
      return this.filtroString
    },
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro, this.resolverFiltroParaEnviar(), this.filtroCustom?.id ?? 0)
        .then(async response => {
          if (response.data && response.data.valores && response.data.valores.length > 0) {
            const ids = response.data.valores.map(i => i.id)
            try {
              const statusResp = await envioHistoricoApi.obterStatus(14, ids) // 14 = ETipoRotina.PortalDeDocumentos
              const statusMap = {}
              if (statusResp.data) {
                statusResp.data.forEach(s => { statusMap[s.idRegistro] = s })
              }
              response.data.valores.forEach(item => {
                const status = statusMap[item.id]
                if (status) {
                  this.$set(item, 'whatsappEnviado', status.whatsappEnviado)
                  this.$set(item, 'emailEnviado', status.emailEnviado)
                }
              })
            } catch (err) {
              this.$erro(err)
            }
          }
          return response
        })
    },
    aplicarFiltroCustom(filtroCustom) {
      this.filtroString = []
      this.filtroCustom = filtroCustom
      this.visibleColunas()
      this.$refs.monitoramentoList.buscar()
    },
    mudarDocSelecionado() {
      this.filtroCustom = null
      this.visibleColunas()
      this.$refs.monitoramentoList.buscar()
    },
    visibleColunas() {
      const docsAtivos = this.filtroString.length > 0 ? this.filtroString : (this.filtroCustom?.filtrosDocs ?? [])
      const filtrando = docsAtivos.length > 0 && !docsAtivos.includes('Todos')

      if (!filtrando) {
        this.resetarEstadoColunas()
        this.visualizacao.colunas.forEach(coluna => {
          if (coluna.grupo) {
            // eslint-disable-next-line no-param-reassign
            coluna.visible = false
          }
        })
        return
      }

      this.resetarEstadoColunas()
      this.visualizacao.colunas.forEach(coluna => {
        if (coluna.thType === 'custom-header' && coluna.grupo) {
          // eslint-disable-next-line no-param-reassign
          coluna.visible = false
          return
        }
        if (!coluna.grupo) return
        const doc = Object.keys(DOC_TO_COLUNA).find(d => DOC_TO_COLUNA[d] === coluna.field)
        // eslint-disable-next-line no-param-reassign
        coluna.visible = !!doc && docsAtivos.includes(doc)
      })
    },
    getDocsAtivos() {
      const mapping = {
        situacaoFiscal: 'Situação Fiscal',
        dctfWeb: 'Declaração DCTFWeb',
        cndRfbPgft: 'CND RFB/PGFN',
        cndFgts: 'CND FGTS',
        cndTrabalhista: 'CND Trabalhista',
        cndEstadual: 'CND Estadual',
        cndMunicipal: 'CND Municipal',
        simplesNacional: 'Parcelamento DAS',
        pert: 'Parcelamento PERT',
        relp: 'Parcelamento RELP',
        rfb: 'Parcelamento RFB',
        naoPrevidenciario: 'Parcelamento Não Previdenciário',
        simplificadoPrevidenciario: 'Parcelamento Simplificado Previdenciário',
        pgfn: 'Parcelamento PGFN',
        das: 'DAS',
      }

      const docs = []
      this.visualizacao.colunas.forEach(col => {
        if (col.visible !== false && mapping[col.field]) {
          docs.push(mapping[col.field])
        }
      })
      return docs.length > 0 ? docs : null
    },
    abrirEnvioEmail(row) {
      this.empresaEmailSelecionada = row
      this.$nextTick(() => {
        if (this.$refs.modalEnvioEmail) {
          this.$refs.modalEnvioEmail.abrirModal()
        }
      })
    },
    enviarEmailAction(itens) {
      if (itens.emailsPara.length === 0 && itens.emailsCc.length === 0) {
        this.$erro('Informe ao menos um e-mail')
        return
      }

      this.descricaoLoading = 'Aguarde! Enviando e-mail.'
      this.isLoading = true

      const docs = this.getDocsAtivos()
      const empresa = this.empresaEmailSelecionada

      const payload = {
        emailsPara: itens.emailsPara,
        emailsCc: itens.emailsCc,
        mensagemAdicional: itens.mensagensAdicional,
        definirEmailPadrao: itens.definirEmailPadroes,
        docs: docs ? docs.join(',') : null,
      }

      api.enviarEmail(empresa.id, payload)
        .then(() => {
          this.$sucesso('E-mail enviado com sucesso')
          this.$set(empresa, 'emailEnviado', true)
        })
        .catch(err => {
          this.$erro(err.response?.data?.message || 'Não foi possível enviar o e-mail.')
        })
        .finally(() => {
          this.isLoading = false
          this.descricaoLoading = ''
          this.empresaEmailSelecionada = null
        })
    },
    enviarEmailEmLote(nome, payload) {
      const docs = this.resolverFiltroParaEnviar()
      return api.enviarEmLote(nome, payload, docs.length > 0 ? docs : null)
    },
    abrirWhatsapp(row) {
      this.descricaoLoading = 'Aguarde!'
      this.isLoading = true

      const docs = this.getDocsAtivos()

      api.getDocWhatsapp(row.id, docs)
        .then(payload => {
          this.isLoading = false
          this.descricaoLoading = ''
          this.mostrarModalWhatsapp(row, payload.data)
        })
        .catch(err => {
          this.isLoading = false
          this.descricaoLoading = ''
          this.$erro(err.response?.data?.message || 'Não foi possível gerar o link do WhatsApp.')
        })
    },
    mostrarModalWhatsapp(row, linkArquivo) {
      const dataVencimento = this.getDataVencimento()

      const statusCnds = []
      const rfbStatus = this.obterStatusTraduzido(row.cndRfbPgft)
      if (rfbStatus !== '-') statusCnds.push(`CND RFB/PGFN ${rfbStatus}`)

      const fgtsStatus = this.obterStatusTraduzido(row.cndFgts)
      if (fgtsStatus !== '-') statusCnds.push(`CND FGTS ${fgtsStatus}`)

      const trabStatus = this.obterStatusTraduzido(row.cndTrabalhista)
      if (trabStatus !== '-') statusCnds.push(`CND Trabalhista ${trabStatus}`)

      const estStatus = this.obterStatusTraduzido(row.cndEstadual)
      if (estStatus !== '-') statusCnds.push(`CND Estadual ${estStatus}`)

      const munStatus = this.obterStatusTraduzido(row.cndMunicipal)
      if (munStatus !== '-') statusCnds.push(`CND Municipal ${munStatus}`)

      const listDocs = statusCnds.join(', ')

      const mensagemBase = `Olá *${row.razaoSocial}* segue link para download do(s) seguinte(s) documento(s):\r\n\r\n${listDocs}\r\n\r\nApós baixar, solicitamos que faça a conferência dos dados!\r\n\r\nO link ficará disponível até ${dataVencimento}\r\n${linkArquivo}`

      this.$swal({
        width: 680,
        title: '<span style="color: #E37A47; font-size: 1.8rem; font-weight: 500;">Mensagem</span>',
        html: `
          <div style="font-size: 1rem; color: #2C3E50; line-height: 1.6; text-align: center; white-space: pre-wrap; font-family: Montserrat, -apple-system, 'Segoe UI', sans-serif;">Olá *${row.razaoSocial}* segue link para download do(s) seguinte(s) documento(s):<br><br>${listDocs}<br><br>Após baixar, solicitamos que faça a conferência dos dados!<br><br>O link ficará disponível até ${dataVencimento}<br><a href="${linkArquivo}" target="_blank" style="color: #E37A47; text-decoration: underline; font-weight: 500;">Link do arquivo</a></div>
        `,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'WhatsApp',
        denyButtonText: 'Copiar link',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-primary mr-50',
          denyButton: 'btn btn-outline-primary mr-50',
          cancelButton: 'btn btn-outline-danger mr-50',
          actions: 'swal2-actions-custom',
        },
        allowOutsideClick: true,
      }).then(result => {
        if (result.isConfirmed) {
          const url = `https://wa.me/?text=${encodeURIComponent(mensagemBase)}`
          window.open(url)
          this.$set(row, 'whatsappEnviado', true)
          this.registrarEnvioWhatsappManual(row, linkArquivo)
        } else if (result.isDenied) {
          this.$swal('Copiado!', '', 'success')
          navigator.clipboard.writeText(linkArquivo)
          this.$set(row, 'whatsappEnviado', true)
          this.registrarEnvioWhatsappManual(row, linkArquivo)
        }
      })
    },
    obterStatusTraduzido(status) {
      if (status === 'regular') return 'Regular'
      if (status === 'irregular') return 'Irregular'
      return '-'
    },
    registrarEnvioWhatsappManual(row, linkArquivo) {
      const payload = {
        tipoRotina: 14, // Portal de Documentos
        tipoCanal: 1, // 1 = WhatsApp
        tipoRegistro: 8, // Portal de Documentos
        idRegistro: row.id,
        empresaId: row.id,
        destinatario: 'WhatsApp',
        assunto: 'Monitoramento 360',
        urlAnexo: linkArquivo,
      }
      envioHistoricoApi.registrarManual(payload).catch(err => this.$erro(err))
    },
    getDataVencimento() {
      return moment().add(15, 'days').format('DD/MM/YYYY')
    },
  },
}
</script>
